module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item border-left-0"
  }, [_c('a', {
    staticClass: "nav-link",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/icon/home.png"),
      "height": "40"
    }
  })])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "container mt-1 mb-3"
  }, [(_vm.exam && !_vm.isFinish) ? _c('live-player', {
    attrs: {
      "liveData": _vm.exam
    },
    on: {
      "finish": _vm.finish
    }
  }) : _c('div', {
    staticClass: "exam-result bg-white mt-5 mb-3"
  }, [(_vm.score) ? _c('div', [_vm._l((_vm.score.sectionResults), function(section, index) {
    return _c('p', {
      key: index
    }, [_vm._v("您的 " + _vm._s(section.name) + " 得分：" + _vm._s(section.score))])
  }), _vm._v(" "), _c('hr'), _vm._v("\n        您的考試總分：" + _vm._s(_vm.score.totalScore)), _c('br')], 2) : _c('div', [_vm._v("\n        您尚未完成這份考卷\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-block w-25 mx-auto",
    staticStyle: {
      "margin-top": "4.5em"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_vm._v("考試")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71c1828e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ExamPlayer.vue
// module id = 741
// module chunks = 1